import React from 'react';

const UniBr = (props) => {
  return (
    <br />
  );
};

export default UniBr;